// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import MaterialsArray from './components/MaterialsArray';

const PECapstoneOpEdPaper = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Prompt Instructions TL" instructions="What is the constructed response prompt instructions in TL?" />
      <Controller
        control={control}
        name="content.prompt_instructions_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt_instructions_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Prompt Instructions EN" instructions="What is the constructed response prompt instructions in EN?" />
      <Controller
        control={control}
        name="content.prompt_instructions_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt_instructions_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="Prompt" instructions="What is the constructed response prompt?" />
      <Controller
        control={control}
        name="content.prompt"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="4" title="Summarized Prompt (EN)" instructions="What is the shortened version of the constructed response prompt (in English) to display prior to schoolhouse response?" />
      <Controller
        control={control}
        name="content.summary_prompt_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.summary_prompt_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="5" title="Response" instructions="Write the schoolhouse response that will be shown to the student to let them know what their response could have looked like." />
      <Controller
        control={control}
        name="content.response"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.response} />}
      />

      <Divider className="mt-16" />

      <NumberedHeading number="6" title="Header Title" instructions="Please add the header title for the top of the newspaper." />
      <Controller
        control={control}
        name="content.title"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Title"
            placeholder="Title"
            error={!!errors.content?.title}
            helperText={errors.content?.title?.message}
            variant="outlined"  
            fullWidth
            required
            dir={inputDir}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="7" title="Header Subtitle" instructions="Please add the header subtitle for the top of the newspaper." />
      <Controller
        control={control}
        name="content.subtitle1"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Subtitle"
            placeholder="Subtitle"
            error={!!errors.content?.subtitle1}
            helperText={errors.content?.subtitle1?.message}
            variant="outlined"  
            fullWidth
            required
            dir={inputDir}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="8" title="Header Second Subtitle" instructions="Please add the second header subtitle for the top of the newspaper." />
      <Controller
        control={control}
        name="content.subtitle2"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Subtitle 2"
            placeholder="Subtitle 2"
            error={!!errors.content?.subtitle2}
            helperText={errors.content?.subtitle2?.message}
            variant="outlined"  
            fullWidth
            dir={inputDir}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="9" title="Send Email" instructions="If this is to be sent to an email, check the box." />
      <Controller
        control={control}
        name='content.send_email'
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox 
                onChange={(ev) => {
                  field.onChange(ev.target.checked);
                }}
                checked={field.value}
              />
            }
            label='Send Email'
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="10" title="Email Destination" instructions="If this is to be emailed, what is the destination?" />
      <Controller
        control={control}
        name="content.email_destination"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Email Destination"
            placeholder="Email Destination"
            error={!!errors.content?.email_destination}
            helperText={errors.content?.email_destination?.message}
            variant="outlined"  
            fullWidth
            required
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="11" title="Subject Line" instructions="Please add the subject line for the email." />
      <Controller
        control={control}
        name="content.email_subject"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Subject Line"
            placeholder="Subject Line"
            error={!!errors.content?.email_subject}
            helperText={errors.content?.email_subject?.message}
            variant="outlined"  
            fullWidth
            required
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="12" title="Materials" instructions="Using the controls below, add the Page IDs for the materials in this TLO. LEAVE FOR DEVS" />
      <Controller 
        control={control}
        name="content.materials"
        render={({ field }) => <MaterialsArray {...{control, errors }} />}
      />
    </div>
  );
};

export default PECapstoneOpEdPaper;